import { URLS_CONFIG } from 'config';

export default (id, role) => URLS_CONFIG[!role || role === 'admin' ? 'companyAdmin' : 'host'].manageGame.replace(':id', id);
